module.exports = __webpack_public_path__ + "img/list.71241531.svg";